import { call, put, takeLatest } from 'redux-saga/effects';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { ADYEN_PAYMENT_METHODS_SUCCESS, ADYEN_PAYMENT_METHODS_ERROR, ADYEN_PAYMENT_METHODS_REQUEST, SUBMIT_ADYEN_PAYMENT_REQUEST, SUBMIT_ADYEN_PAYMENT_SUCCESS, SUBMIT_ADYEN_PAYMENT_ERROR, SUBMIT_ADDITIONAL_ADYEN_PAYMENT_REQUEST, SUBMIT_ADDITIONAL_ADYEN_PAYMENT_SUCCESS, SUBMIT_ADDITIONAL_ADYEN_PAYMENT_ERROR, REMOVE_ADYEN_STORED_PAYMENT_REQUEST, REMOVE_ADYEN_STORED_PAYMENT_SUCCESS, REMOVE_ADYEN_STORED_PAYMENT_ERROR, } from '../constants';
import { setErrorCode } from '../redux/Actions/ErrorAction';
export function* getAdyenPaymentMethodsCall({ payload }) {
    const { tenantId, customerId, postBody, successCallback, errorCallback } = payload;
    try {
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.adyenPayment.getPaymentMethods, null, headers, postBody);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: ADYEN_PAYMENT_METHODS_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: ADYEN_PAYMENT_METHODS_ERROR,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: ADYEN_PAYMENT_METHODS_ERROR,
        });
        errorCallback && errorCallback(error);
    }
}
export function* getAdyenPaymentMethodsSaga() {
    yield takeLatest(ADYEN_PAYMENT_METHODS_REQUEST, getAdyenPaymentMethodsCall);
}
export function* submitAdyenPaymentCall({ payload }) {
    const { tenantId, customerId, postBody, successCallback, errorCallback } = payload;
    try {
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.adyenPayment.submitPayment, null, headers, postBody);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: SUBMIT_ADYEN_PAYMENT_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: SUBMIT_ADYEN_PAYMENT_ERROR,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: SUBMIT_ADYEN_PAYMENT_ERROR,
        });
        errorCallback && errorCallback(error);
    }
}
export function* submitAdyenPaymentSaga() {
    yield takeLatest(SUBMIT_ADYEN_PAYMENT_REQUEST, submitAdyenPaymentCall);
}
export function* submitAdditionalAdyenPaymentCall({ payload }) {
    const { tenantId, customerId, postBody, successCallback, errorCallback } = payload;
    try {
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.adyenPayment.submitAdditionalPayment, null, headers, postBody);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: SUBMIT_ADDITIONAL_ADYEN_PAYMENT_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: SUBMIT_ADDITIONAL_ADYEN_PAYMENT_ERROR,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: SUBMIT_ADDITIONAL_ADYEN_PAYMENT_ERROR,
        });
        errorCallback && errorCallback(error);
    }
}
export function* submitAdditionalAdyenPaymentSaga() {
    yield takeLatest(SUBMIT_ADDITIONAL_ADYEN_PAYMENT_REQUEST, submitAdditionalAdyenPaymentCall);
}
export function* removeAdeynStoredPaymentCall({ payload }) {
    const { tenantId, customerId, postBody, successCallback, errorCallback, queryProps } = payload;
    const params = { queryProps };
    try {
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.adyenPayment.removeStoredPayment, params, headers, postBody);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: REMOVE_ADYEN_STORED_PAYMENT_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: REMOVE_ADYEN_STORED_PAYMENT_ERROR,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: REMOVE_ADYEN_STORED_PAYMENT_ERROR,
        });
        errorCallback && errorCallback(error);
    }
}
export function* removeAdeynStoredPaymentSaga() {
    yield takeLatest(REMOVE_ADYEN_STORED_PAYMENT_REQUEST, removeAdeynStoredPaymentCall);
}
